import AboutTeam from "../../components/AboutUsPage/AboutTeam";
import GetInTouch from "../../components/AboutUsPage/GetInTouch";
import AboutUsHeroSection from "../../components/AboutUsPage/Hero";
import Indicator from "../../components/AboutUsPage/Indicator";
import TeamCards from "../../components/AboutUsPage/TeamCards";
// import Testimonial from "../../components/AboutUsPage/Testimonial";
import TrustedCompanies from "../../components/AboutUsPage/TrustedCompanies";

const AboutUsPage = () => {
  return (
    <main>
      <AboutUsHeroSection />
      <Indicator />
      <AboutTeam />
      <TrustedCompanies />
      <TeamCards />
      {/* <Testimonial /> */}
      <GetInTouch />
    </main>
  );
};

export default AboutUsPage;
